<template>
  <div class="PassengerInfos">
    <div class="PassengerInfos-wrapper">
      <div class="queryInfos-wrapper" v-if="value.passengerInfos.length>0">
        <div class="queryInfos-item" @click="addTraveller($event,linkmanInfo.RoleID, linkmanInfo.Cards)" v-for="(linkmanInfo,index) in value.passengerInfos">
          <!-- <label  class="checkBox" :for="linkmanInfo.RoleID" @click="handleCheckbox">
            <input type="checkbox" :id="linkmanInfo.RoleID" v-model="value.selectTraveller" :value="multipleSelection"
              v-for="multipleSelection in  multipleSelections" v-if="multipleSelection==linkmanInfo.RoleID" />
          </label> -->
          <!-- <div class="queryInfos-item-content">
            <div>
              <div>
                <span>{{linkmanInfo.RoleName}}</span>
              </div>
              <div v-if="linkmanInfo.UserAccount">
                <span>{{$t('mall.Phone')}}</span>
                <span>{{linkmanInfo.UserAccount}}</span>
              </div>
              <div v-if="linkmanInfo.department">
                <span>{{$t('mall.Department')}}</span>
                <span>{{linkmanInfo.department}}</span>
              </div>
            </div>
            <div class="queryInfos-rightItem" >
              <i class="fa fa-chevron-right"></i>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .checkBox {
    width: 1.276rem;
    height: 1.276rem;
  }

  .checkBox input {
    transform: translate3d(50%, 50%, 0);
    width: 0.478rem;
    height: 0.478rem;
    margin-top: 0.06rem;
  }

  .queryInfos-item {
    display: flex;
    padding: 0.266rem 0.266rem 0.266rem 0;
    background-color: #fff;
    margin-top: 0.266rem;
    justify-content: space-between;
    align-items: center;
    font-size: 0.3192rem;
    color: #666
  }

  .queryInfos-item-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%
  }

  .queryInfos-rightItem>i {
    font-size: 0.478rem;
    color: #999;
    vertical-align: middle;
  }

  .queryInfos-leftItem {
    display: flex;
    align-items: center
  }


  .PassengerInfos-item {
    display: flex;
    padding: 0 0.266rem;
    justify-content: space-between;
    align-items: center;
  }


  .addContent {
    width: 2.6rem;
    margin-right: 0.266rem;
    font-size: 0.372rem;
    padding: 0.133rem 0;
    border: 1px solid rgb(18, 163, 255);
    border-radius: 0.106rem;
    text-align: center;
  }

</style>
<script>
  export default {
    data() {
      return {
        flag: true,
        multipleSelections: [],
        PassengerInfos: {},
        Travellers: [],
        path: ''
      }
    },
    props: ['value'],
    computed: {
      ApplyArea() {
        return this.$route.query.ApplyArea;
      },
      CardTypes() {
        return this.$route.query.CardTypes;
      },
      CardTypeTypes() {
        return this.$store.getters.categorys.types.CardType;
      },
      ApplyAreaTypes() {
        return this.$store.getters.categorys.types.ApplyArea;
      },
      BookingType() {
        return this.$route.query.BookingType;
      }
    },
    mounted() {
      let __self = this;
      __self.path = __self.$route.path;
      if ($utils.Storage.Consumers != undefined) {
        let Consumers = JSON.parse($utils.Storage.Consumers);
        for (let i = 0; i < Consumers.length; i++) {
          if (Consumers[i].ConsumerID) {
            __self.value.selectTraveller.push(Consumers[i].ConsumerID);
          }
        }
      }
    },
    watch: {
      'value.passengerInfos'() {
        this.__init();
      }
    },
    methods: {
      __init() {
        let __self = this;
        __self.multipleSelections = [];
        __self.PassengerInfos = {};
        for (let i = 0; i < __self.value.passengerInfos.length; i++) {
          let Cards = __self.value.passengerInfos[i].Cards;
          for (let j = 0; j < Cards.length; j++) {
            if (Cards[j].CardType == 0) {
              Cards[j].CardType = 1138;
            }
            if (__self.ApplyArea == __self.ApplyAreaTypes.Internal) {
              if (Cards[j].CardType == __self.CardTypeTypes.IDCard) {
                __self.value.passengerInfos[i].Cards = [];
                __self.value.passengerInfos[i].Cards.push(Cards[j]);
              }
            } else {
              if (Cards[j].CardType != __self.CardTypeTypes.IDCard) {
                __self.value.passengerInfos[i].Cards = [];
                __self.value.passengerInfos[i].Cards.push(Cards[j]);
              }
            }
          }
          __self.multipleSelections.push(__self.value.passengerInfos[i].RoleID);
        }
      },
      handleCheckbox(e) {
        e.stopPropagation();
      },
      addTraveller(e, RoleID, Cards) {
        let __self = this;
        if (__self.$route.path == '/mall/selectTraveller') {
          return
        }
        let CardType = "";
        let query = {
          BookingType: __self.BookingType
        }
        if (__self.CardTypes == undefined) {
          query.CardType = 1138;
        } else {
          query.CardType = __self.CardTypes;
        }
        if (RoleID == undefined) {
          query.RoleID = undefined;
        } else {
          query.RoleID = RoleID;
          query.ApplyArea = __self.ApplyArea;
        }
        __self.$router.push({
          path: '/mall/addTraveller',
          query: query
        })
      },
    },
  }

</script>
